import * as type from '../ActionTypes';

const initialState = {
  countryList: [],
  stateList: [],
  error: null,
  stateError: null
};

export default function countryList(state = initialState, action: any) {
  switch (action.type) {
    case type.GET_COUNTRY_LIST:
      return {
        ...state,
        error: null
      };
    case type.GET_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        countryList: action.data
      };
    case type.GET_COUNTRY_LIST_FAILURE:
      return {
        ...state,
        error: action.message
      };
    case type.GET_STATE_SUCCESS:
      return {
        ...state,
        stateList: action.data
      };
    case type.GET_STATE_ERROR:
      return {
        ...state,
        stateList: [],
        stateError: action.message
      };
    default:
      return state;
  }
}
